import { render, staticRenderFns } from "./SuppliesStockStatus.vue?vue&type=template&id=5ce63040&scoped=true&"
import script from "./SuppliesStockStatus.vue?vue&type=script&lang=js&"
export * from "./SuppliesStockStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce63040",
  null
  
)

export default component.exports